export default __webpack_public_path__ + "static/media/power.e62a033a.png";